import React from "react";
import {
  FormControl,
  Select,
  SelectChangeEvent,
  MenuItem,
  Typography,
} from "@mui/material";
import InputErrors from "./InputErrors";

export interface ISelectOption {
  value: string;
  label: string;
}

export interface IFormSelectFieldProps {
  label: string;
  name: string;
  value: string;
  placeholder: string;
  options: ISelectOption[];
  errors?: string[];
  onChange: (_value: string) => void;
  disabled?: boolean;
  className?: string;
}

const FormSelectField: React.FC<IFormSelectFieldProps> = ({
  label,
  name,
  value,
  placeholder,
  options,
  errors = [],
  onChange,
  disabled = false,
  className = "m-t-20",
}) => (
  <FormControl className={className} fullWidth>
    <Typography className="f-s-14 m-b-10">{label}</Typography>
    <Select
      size="small"
      name={name}
      value={value || placeholder}
      error={errors.length > 0}
      onChange={(e: SelectChangeEvent) => onChange(e.target.value)}
      disabled={disabled}
    >
      <MenuItem disabled value={placeholder} className="f-s-14">
        {placeholder}
      </MenuItem>
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
    {errors.length > 0 && <InputErrors errors={errors} />}
  </FormControl>
);

export default FormSelectField;
